export const NOTIFICATION_PARENT_TYPE = {
  BOOKINGS: 'bookings', // booking start
  BOOKINGS_INVITE: 'bookings_invite', // booking invite
  BOOKINGS_UPDATE: 'bookings_update',  // booking update
  BOOKINGS_DELETE: 'bookings_delete',  // booking delete
  BOOKINGS_NEAR_END: 'bookings_near_end', // booking nearly end
  ISSUES: 'issues', // issue create
  ISSUES_STATUS_UPDATE: 'issues_status_update', // issue update
  ORDERS: 'orders', // order create
  ORDERS_STATUS_UPDATE: 'orders_status_update', // order update
}
